import request from '../../../../../api/request';

import {
  CertificateType,
  PetitionType,
  PricingFormDataResponse,
  StudyPlanTitulationDetail,
} from './types';

const BASE = '/maintainers-portal/financial-portal/settings/pricing';

export function pricingFormDataRequest() {
  return request<PricingFormDataResponse>(`${BASE}/form-data`);
}

export function saveCertificatePricesRequest(
  certificateTypes: CertificateType[],
) {
  return request(`${BASE}/certificates`, {
    method: 'PUT',
    data: { certificateTypes },
  });
}

export function savePetitionPricesRequest(petitionTypes: PetitionType[]) {
  return request(`${BASE}/petitions`, {
    method: 'PUT',
    data: { petitionTypes },
  });
}

export function studyPlanTitulationListRequest(academicLevelId: number) {
  return request<StudyPlanTitulationDetail>(
    `${BASE}/academic-levels/${academicLevelId}/study-plans`,
  );
}

export function studyPlanTitulationUpdateRequest(
  academicLevelId: number,
  data: {
    paymentRequired: boolean;
    paymentAmount?: number;
    titulationPaymentId?: number | null;
    studyPlans: {
      studyPlanId: number;
      hasOverride: boolean;
      paymentAmount?: number;
    }[];
  },
) {
  return request(`${BASE}/academic-levels/${academicLevelId}/study-plans`, {
    method: 'PUT',
    data,
  });
}
